export default {
    InternalOrderList: {
        information: 'View return logistics information',
        number: 'Count',
        company: 'Logistics company',
        document: 'Job Id/Tracking No.',
        Operation: 'Action',
    },
};
